import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet, doAsyncPost } from '@/api/async-util'
import Notify from 'quasar/src/plugins/Notify.js';

const types = {
    PROCESS_CART: createAsyncMutation('PROCESS_CART'),
    SYNC_CART: createAsyncMutation('SYNC_CART'),
    SYNC_CART_RENEW_UPGRADE: createAsyncMutation('SYNC_CART_RENEW_UPGRADE'),
    UNLOCK_CART_FOR_EDITING: createAsyncMutation('UNLOCK_CART_FOR_EDITING'),
    IS_CART_ORDER_EDITABLE: createAsyncMutation('IS_CART_ORDER_EDITABLE'),
}

const cart = {
    state: {
        cart: {
            orderID: null,
            customerID: null,
            currency: 0,
            cartItems: []
        },
        installIdDismissed: false,
        cartItemAdded: false,
        reinstatementLicenseItems: null,
        showReinstatementCostDialog: false,
        showLicenseOemLockedDialog: false,
        oemLockedLicenseItems: null,
        continueToVerifyOrderClicked: false,
        cartLockedForProcessing: false,
        checkoutSessionId: null,
    },
    mutations: {
        update_installIdDismissed(state, value) {
            state.installIdDismissed = value
        },
        update_cartCustomer(state, customer) {
            state.cart.customerID = customer.id
            this.commit('update_currency', customer.country)
        },
        update_currency(state, currency) {
            if (currency !== 0 && currency !== 1)
                state.cart.currency = 0
            else
                state.cart.currency = currency
        },
        update_cart(state, cart) {
            state.cart = cart
        },
        update_cartItemAdded(state, added) {
            state.cartItemAdded = added
        },
        add_cartItem(state, item) {
            state.cart.cartItems.push(item)
        },
        add_cartItems(state, items) {
            state.cart.cartItems.push.apply(state.cart.cartItems, items)
        },
        remove_cartItem(state, item) {
            let index = state.cart.cartItems.findIndex(i => i.id == item.id)
            state.cart.cartItems.splice(index, 1)
            let linkedCartItemIndex = state.cart.cartItems?.findIndex(i => i.product.isUpgrade && i.licenseID == item.licenseID)
            if (linkedCartItemIndex > -1)
                state.cart.cartItems.splice(linkedCartItemIndex, 1)
            if (state.cart.cartItems.length == 0) state.installIdDismissed = false
        },
        update_cartItemQuantity(state, item) {
            let cartItem = state.cart.cartItems?.find(i => i.id == item.id)
            cartItem.quantity = item.quantity

            if (cartItem.quantity > 1) {
                cartItem.installationID = ''
            }
        },
        validate_cartItem(state, item) {
            let cartItem = state.cart.cartItems?.find(i => i.id == item.id)
            cartItem.discountCode = item.discountCode
            cartItem.installationID = item.installationID
        },
        update_reinstatementLicenseItems(state, items) {
            state.reinstatementLicenseItems = items
        },

        set_reinstatementItemsViewed(state, viewed) {
            for (let item of state.cart.cartItems) {
                if (item.isLapsedSubscriptionReinstatementItem) item.isLapsedSubscriptionReinstatementItemViewed = viewed
            }
            state.reinstatementLicenseItems = null
        },
        set_showReinstatementCostDialog(state, show) {
            state.showReinstatementCostDialog = show
        },

        update_oemLockedLicenseItems(state, items) {
            state.oemLockedLicenseItems = items
        },
        set_licenseOemLockedItemsViewed(state, viewed) {
            for (let item of state.cart.cartItems) {
                if (item.isDiscountCodeLockedToOemItem) item.IsDiscountCodeLockedToOemItemViewed = viewed
            }
            state.oemLockedLicenseItems = null
        },
        set_showLicenseOemLockedDialog(state, show) {
            state.showLicenseOemLockedDialog = show
        },

        logout_cart(state) {
            state.cart = {
                orderID: null,
                customerID: null,
                currency: state.cart.currency,
                cartItems: []
            }
            state.installIdDismissed = false
            state.continueToVerifyOrderClicked = false
            state.cartLockedForProcessing = false
            state.checkoutSessionId = null
        },
        reset_cart(state) {
            state.cart.orderID = null
            state.cart.cartItems = []
            state.installIdDismissed = false
            state.continueToVerifyOrderClicked = false
            state.cartLockedForProcessing = false
            state.checkoutSessionId = null
        },
        update_continueToVerifyOrderClicked(state, clicked) {
            state.continueToVerifyOrderClicked = clicked
        },
        update_cartLockedForProcessing(state, locked) {
            state.cartLockedForProcessing = locked
        },
        update_checkoutSessionId(state, sessionId) {
            state.checkoutSessionId = sessionId
        },
    },
    actions: {
        updateCartCustomer(store, customer) {
            this.dispatch('isCartOrderEditable', store.getters.cart.orderID).then(() => {
                if (!store.getters.cartLockedForProcessing) {
                    store.commit('update_cartCustomer', customer)
                    this.dispatch('syncCart', store.getters.cart)
                }
            })
        },
        updateCurrency(store, currency) {
            this.dispatch('isCartOrderEditable', store.getters.cart.orderID).then(() => {
                if (!store.getters.cartLockedForProcessing) {
                    store.commit('update_currency', currency)
                    this.dispatch('syncCart', store.getters.cart)
                }
            })
        },
        addCartItem(store, payload) {

            this.dispatch('isCartOrderEditable', store.getters.cart.orderID).then(() => {
                if (!store.getters.cartLockedForProcessing) {

                    store.commit('update_cartItemAdded', false)
                    store.commit('update_currency', payload.currency)
                    if (payload.product.isSubscription || payload.product.isUpgrade) {
                        //return, subscription and upgrade handled in another action path
                        return
                    }

                    let itemIndex = store.getters.cart.cartItems?.findIndex(i => i.product.id == payload.product.id)
                    if (itemIndex > -1) {
                        Notify.create({
                            badgeClass: 'hidden',
                            type: 'info',
                            position: 'bottom',
                            message: payload.product.fullDescription + ' already exists in your shopping cart. If you want to purchase multiple licenses you can edit the quantity at the shopping cart page.'
                        })
                        return
                    }

                    let item = {
                        product: payload.product,
                        discountCode: payload.discountCode,
                        installationID: payload.installationID,
                        quantity: 1,
                    }
                    store.commit('add_cartItem', item)

                    this.dispatch('syncCart', store.getters.cart).then(() => {
                        Notify.create({
                            badgeClass: 'hidden',
                            type: 'positive',
                            position: 'bottom',
                            message: payload.product.fullDescription + ' has been added to your cart.'
                        })
                        store.commit('update_cartItemAdded', true)
                    })

                }
                else {
                    Notify.create({
                        badgeClass: 'hidden',
                        type: 'info',
                        position: 'bottom',
                        message: 'Your cart is locked for processing. <a href="/store/cart" class="text-white" style="text-decoration: underline;">Go to cart</a> to unlock it and make changes.',
                        html: true,
                    })
                }
            }).catch(err => { })

        },
        removeCartItem(store, item) {
            this.dispatch('isCartOrderEditable', store.getters.cart.orderID).then(() => {
                if (!store.getters.cartLockedForProcessing) {
                    store.commit('remove_cartItem', item)
                    this.dispatch('syncCart', store.getters.cart)
                }
            }).catch(err => { })
        },

        updateCartItemQuantity(store, item) {
            this.dispatch('isCartOrderEditable', store.getters.cart.orderID).then(() => {
                if (!store.getters.cartLockedForProcessing) {
                    store.commit('update_cartItemQuantity', item)
                    this.dispatch('syncCart', store.getters.cart)
                }
            }).catch(err => { })
        },
        validateCartItem(store, item) {
            this.dispatch('isCartOrderEditable', store.getters.cart.orderID).then(() => {
                if (!store.getters.cartLockedForProcessing) {
                    store.commit('validate_cartItem', item)
                    this.dispatch('syncCart', store.getters.cart)
                }
            }).catch(err => { })
        },
        syncRenewUpgradeItems(store, payload) {
            this.dispatch('isCartOrderEditable', store.getters.cart.orderID).then(() => {
                if (!store.getters.cartLockedForProcessing) {
                    store.commit('update_reinstatementLicenseItems', null)
                    store.commit('set_showReinstatementCostDialog', false)

                    this.dispatch('syncCartRenewUpgradeItems', payload).then(() => {
                        let exists = false
                        let key = ''
                        for (let syncItem of this.state.syncCartRenewUpgradeData) {
                            if (store.getters.cart.cartItems?.find(i => i.licenseID == syncItem.licenseID)) {
                                key = syncItem.licenseKey
                                exists = true
                                break
                            }
                        }

                        if (exists) {
                            Notify.create({
                                badgeClass: 'hidden',
                                type: 'negative',
                                position: 'bottom',
                                message: 'An upgrade or renewal product for ' + key + ' already exists in the cart'
                            })
                            return
                        }

                        store.commit('update_cartItemAdded', false)
                        if (this.state.syncCartRenewUpgradeData && this.state.syncCartRenewUpgradeData.length > 0) {
                            store.commit('add_cartItems', this.state.syncCartRenewUpgradeData)
                            this.dispatch('syncCart', store.getters.cart).then(() => {
                                for (let i of this.state.syncCartRenewUpgradeData) {
                                    Notify.create({
                                        badgeClass: 'hidden',
                                        type: 'positive',
                                        position: 'bottom',
                                        message: i.description + ' has been added to your cart.'
                                    })
                                }

                                let items = this.state.syncCartData.cartItems?.filter(obj => { return obj.isLapsedSubscriptionReinstatementItem == true && obj.isLapsedSubscriptionReinstatementItemViewed == false })
                                store.commit('update_reinstatementLicenseItems', items)
                                if (items && items.length > 0) {
                                    store.commit('set_showReinstatementCostDialog', true)
                                }
                                store.commit('update_cartItemAdded', true)
                            })
                        }
                    })
                }
            }).catch(err => { })
        },

        // GET
        isCartOrderEditable(store, orderId) {
            let url = api.cart + 'IsCartOrderEditable/' + orderId
            return doAsyncGet(store, { url, mutationTypes: types.IS_CART_ORDER_EDITABLE }).then(() => {
                store.commit('update_cartLockedForProcessing', !this.state.isCartOrderEditableData)
            })
        },

        // POST
        processPrepaidCart(store, payload) {
            let url = api.cart + 'Process/Prepaid'
            return doAsyncPost(store, { url, mutationTypes: types.PROCESS_CART, payload }).then(() => {
                store.commit('reset_cart')
            })
        },
        syncCart(store, cart) {
            let url = api.cart + 'Sync'
            const payload = { cart: cart }
            return doAsyncPost(store, { url, mutationTypes: types.SYNC_CART, payload }).then(() => {
                // Check if the cart has items using a discount code that is locked to an OEM. Set displaying properties.
                this.dispatch('CheckForAndHandleOEMLockedDiscountCodes')
                // Update Cart State
                store.commit('update_cart', this.state.syncCartData)
            }).catch(err => {
                store.commit('reset_cart')
                throw err
            })
        },

        syncCartRenewUpgradeItems(store, payload) {
            let url = api.cart + 'Sync/RenewUpgrade'
            return doAsyncPost(store, { url, mutationTypes: types.SYNC_CART_RENEW_UPGRADE, payload })
        },

        unlockCartForEditing(store, payload) {
            let url = api.cart + 'UnlockCart'
            return doAsyncPost(store, { url, mutationTypes: types.UNLOCK_CART_FOR_EDITING, payload }).then(() => {
                store.commit('update_checkoutSessionId', null)
                store.commit('update_cartLockedForProcessing', false)
                this.dispatch('syncCart', store.getters.cart)
            }).catch(err => {
                store.commit('update_cartLockedForProcessing', true)
            })
        },

        CheckForAndHandleOEMLockedDiscountCodes(store) {
            store.commit('set_showLicenseOemLockedDialog', false)

            let items = this.state.syncCartData.cartItems?.filter(obj => {
                return obj.isDiscountCodeLockedToOemItem == true && obj.isDiscountCodeLockedToOemItemViewed == false
            })
            store.commit('update_oemLockedLicenseItems', items)
            if (items && items.length > 0) {
                store.commit('set_showLicenseOemLockedDialog', true)
            }
        },

        // PUT

        // DELETE
    },
    getters: {
        cart: state => state.cart,
        cartItemAdded: state => state.cartItemAdded,
        reinstatementLicenseItems: state => state.reinstatementLicenseItems,
        showReinstatementCostDialog: state => state.showReinstatementCostDialog,
        oemLockedLicenseItems: state => state.oemLockedLicenseItems,
        showLicenseOemLockedDialog: state => state.showLicenseOemLockedDialog,
        installIdDismissed: state => state.installIdDismissed,
        continueToVerifyOrderClicked: state => state.continueToVerifyOrderClicked,
        cartLockedForProcessing: state => state.cartLockedForProcessing,
        checkoutSessionId: state => state.checkoutSessionId,
    },
    types: types
}

export default cart
